import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class Org {
    static requestData(props) {
        App.log('ORG.REQUEST_DATA', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({
                            ...result.objList[0]?.hospitalNormRequestFormVM,
                            ...result.objList[0]?.hospitalEmgRequestFormVM,
                            ...result.objList[0]?.hospitalRadiatedRequestFormVM,
                            ...result.objList[0]?.hospitalWashedRequestFormVM,
                            ...result.objList[0]?.requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static addProductToRequest(props) {
        App.log('ORG.ADD_PRODUCT', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId,
            // productId: 0,
            productNumber: props.productNumber,
            productTypeId: parseInt(props.productTypeId),
            bloodGroupId: parseInt(props.bloodGroupId),
            expireDate: props.expireDate,
            collectionDate: props.collectionDate,
            cellTypeTest: props.cellTypeTest
        };

        return new Promise((resolve, reject) => {
            fetch(Api.ORG.PRODUCT.ADD_TO_REQUEST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static deleteProductFromRequest(props) {
        App.log('ORG.DELETE_PRODUCT', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId,
            orgProductId: props.orgProductId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.ORG.PRODUCT.REMOVE_FROM_REQUEST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static deliveryRequest(props) {
        App.log('ORG.DELIVERY_REQUEST', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId,
            statusId: 65
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.UPDATE_STATUS, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static editProductInRequest(props) {
        App.log('ORG.EDIT_PRODUCT', App.LOG.FETCH, props);

        const body = {
            orgProductId: props.orgProductId,
            productNumber: props.productNumber,
            productTypeId: parseInt(props.productTypeId),
            bloodGroupId: parseInt(props.bloodGroupId),
            expireDate: props.expireDate,
            collectionDate: props.collectionDate,
            cellTypeTest: props.cellTypeTest
        };

        return new Promise((resolve, reject) => {
            fetch(Api.ORG.PRODUCT.EDIT_FROM_REQUEST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static incomingList(props = {}) {
        App.log('ORG.INCOMING_LIST', App.LOG.FETCH, props);

        const body = {
            productId: props.productId || null,
            productNumber: props.productNumber || null,
            bloodGroupId: props.bloodGroupId || null,
            productTypeId: props.productTypeId || null
        };

        return new Promise((resolve, reject) => {
            fetch(Api.ORG.LIST.INCOMING, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static receiveRequest(props) {
        App.log('ORG.RECEIVE_REQUEST', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId,
            statusId: 62,
            description: props?.description || ''
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.UPDATE_STATUS, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static rejectRequest(props) {
        App.log('ORG.REJECT_REQUEST', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId,
            statusId: 63
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.UPDATE_STATUS, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static requestList() {
        App.log('ORG.REQUEST_LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.ORG.LIST.REQUEST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export default Org;